import { Form, Link } from '@adonisjs/inertia/react'
import { Data } from '@generated/data'
import { router } from '@inertiajs/react';
import { Menu, X } from 'lucide-react';
import { useState } from 'react';
import { ThemeToggle } from '~/components/custom/theme-toggle'

interface MobileNavigationProps {
  user?: Data.User;
  isOrganizationMember: boolean;
}

export default function MobileNavigation({ user,isOrganizationMember }: MobileNavigationProps) {
  const [isOpen, setIsOpen] = useState(false);
  
  const toggleMenu = () => {
    setIsOpen((prev) => !prev)
  }

  const handleClick = () => {
    router.on('finish', () => {
      setIsOpen(false);
    })
  }

  return (
    <header className="relative bg-card border-b border-border px-5">
      <div className="container mx-auto flex h-18 py-4 items-center justify-between">
        <div>
          <Link route="home">ConTroll</Link>
        </div>

        <div>
          {user && (
            <span>Zalogowano jako: {user.nickname}</span>
          )}
        </div>

        <div className="flex items-center gap-3">
          <ThemeToggle />
          <button
            type="button"
            onClick={toggleMenu}
            aria-label={isOpen ? 'Zamknij menu' : 'Otwórz menu'}
            aria-expanded={isOpen}
          >
            <span className="text-2xl">
              {isOpen ? <X /> : <Menu />}
            </span>
          </button>
        </div>
      </div>

      {isOpen && (
        <div className="absolute left-0 top-full z-50 w-full bg-card border-b border-border px-5 py-4 shadow-lg">
          <nav className="flex flex-col gap-4 text-muted-foreground">
            {user ? (
              <>
              <Link route="conventions.list" onClick={handleClick}>Konwenty</Link>
                {isOrganizationMember && (
                  <Link route="organizations.index" onClick={handleClick}>Organizacje</Link>
                )}
                <Link route="profile.show" onClick={handleClick}>Profil</Link>
                <Form route="session.destroy">
                  <button type="submit" className="cursor-pointer">
                    Wyloguj
                  </button>
                </Form>
              </>
            ) : (
              <>
                {/* Public since ADR-0014 — and this is the branch most
                    visitors hit, since they arrive on a phone. */}
                <Link route="conventions.list" onClick={handleClick}>Konwenty</Link>
                <Link route="new_account.create" onClick={handleClick}>Zarejestruj się</Link>
                <Link route="session.create" onClick={handleClick}>Zaloguj się</Link>
              </>
            )}
          </nav>
        </div>
      )}
    </header>
  )
}